import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import confetti from "canvas-confetti";

const Share = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const image = params.get("image");

  const url = window.location.href;

  useEffect(() => {
    confetti({
      particleCount: 120,
      spread: 70,
      origin: { y: 0.6 },
    });
  }, []);

  return (
    <div className="share-page">
      <Helmet>
        <title> </title>
        <meta property="og:title" content="My Engivio ROM Result" />
        <meta
          property="og:description"
          content="See your progress and improve your range of motion with Engivio—track, share, and achieve your goals today!"
        />
        <meta
          property="og:image"
          content={
            image ||
            "https://cdn.prod.website-files.com/67bc90cd1b8335e438db061f/67bc90cd1b8335e438db06dd_Featured%20Image%201.png"
          }
        />

        <meta property="og:url" content={url} />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <style>{`
        .share-page {
          margin: 0;
          font-family: Arial, sans-serif;
          background: url('https://dashboard.engiv.io/static/media/auth-bg.8ae93d93abe895f0c45c.jpg');
          height: 100vh;
          width: 100vw;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          overflow: hidden;
        }
        .share-page .preview-img {
          max-height: 80vh;
          max-width: 90vw;
          border-radius: 30px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.4);
          margin-bottom: 20px;
          object-fit: contain;
        }
        .share-page .cta {
          display: inline-block;
          padding: 14px 28px;
          background: #2563eb;
          color: white;
          text-decoration: none;
          font-size: 18px;
          font-weight: bold;
          border-radius: 10px;
          transition: background 0.3s ease;
        }
        .share-page .cta:hover {
          background: #1d4ed8;
        }
      `}</style>

      {image ? (
        <img src={image} alt="ROM Progress" className="preview-img" />
      ) : (
        <p style={{ color: "red" }}>No image found in URL</p>
      )}

      <a href="https://dashboard.engiv.io" className="cta">
        Continue using Engivio! →
      </a>
    </div>
  );
};

export default Share;
